<style lang="scss" src='./Profile.scss' scoped></style>
<template src="./Profile.html"></template>


<script>
import {
  mapState,
  mapActions,
  mapMutations,
} from 'vuex';
import { omit } from 'lodash';

import CommonComponent from '@/components/utils/CommonComponent.vue';

export default {
  name: 'Profile',
  extends: CommonComponent,

  data() {
    return ({
      newUserPhoto: null,
    });
  },

  computed: {
    ...mapState('Profile', {
      user: (state) => state.user,
      userName: (state) => state.userName,
      loading: (state) => state.loading,
    }),
  },

  methods: {
    ...mapActions('Profile', ['apiGetUser', 'apiUpdateUser']),
    ...mapMutations('Profile', ['loadUserInfo']),


    onFileChanged(event) {
      this.G_createUrlFromFile(event, (mImage)=> {
          this.newUserPhoto = mImage;
      });
    },

    async validateData() {
      await this.apiUpdateUser(this.newUserPhoto);
      const userUpdated = {...this.$store.state.user, ...omit(this.user, ['golf_courses']) }; // Admin does not have courses thats why we can not update this
      this.$store.commit('setUser', userUpdated);
      this.$router.go(-1);
    },
  },
  
  beforeMount() {
    this.setShowMenu(false);
    this.setShowBackground(false);
  },

  async mounted() {
    this.apiGetUser();
  },
};

</script>
